import { showSuccess, showResponseError } from 'utils/messages';

import CredentialManagementView from 'app/views/credential_management_view';
import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/carrier_account_details_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .update_account': 'updateAccount',
  },

  initialize() {
    const fields = this.model.get('fields');
    if (fields.credentials) {
      this.manageCredentials = true;
      this.addSubview('credentialManagement', '#credential_management', new CredentialManagementView({
        model: this.model,
        key: 'credentials',
      }));
    }

    if (fields.test_credentials) {
      this.manageTestCredentials = true;
      this.addSubview('testCredentialManagement', '#test_credential_management', new CredentialManagementView({
        model: this.model,
        key: 'test_credentials',
      }));
    }
  },

  context() {
    return {
      id: this.model.id,
      readable: this.model.get('readable'),
      description: this.model.get('description'),
      reference: this.model.get('reference'),
      hasCredentials: this.manageCredentials,
      hasTestCredentials: this.manageTestCredentials,
    };
  },

  updateAccount(e) {
    e.preventDefault();
    const changedAttrs = {};
    let reference;

    if (!this.model.get('reference')) {
      reference = this.$('input#carrier_account_reference').val();
    }

    const newDescription = this.$('input#carrier_account_description').val();
    const creds = this.manageCredentials && this.getSubview('credentialManagement').getUpdateData();
    const testCreds = this.manageTestCredentials && this.getSubview('testCredentialManagement').getUpdateData();

    if (reference) {
      changedAttrs.reference = reference;
    }
    if (newDescription !== this.model.get('description')) {
      changedAttrs.description = newDescription;
    }
    if (creds && !(Object.keys(creds).length === 0)) {
      changedAttrs.credentials = creds;
    }
    if (testCreds && !(Object.keys(testCreds).length === 0)) {
      changedAttrs.test_credentials = testCreds;
    }
    if (!(Object.keys(changedAttrs).length === 0)) {
      this.model.update(changedAttrs, {
        success() {
          showSuccess('Your carrier account was successfully updated');
        },
        error(model, response) {
          showResponseError(response);
        },
      });
    }
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/carrier_account_details_modal.js